import { forwardRef } from "react";
import { Tooltip } from "antd";
import { TooltipPlacement } from "antd/es/tooltip";
import cn from "classnames";
import styles from "./TitleField.module.scss";
import { Icon } from "../icon";
import { useIsMobile } from "~/hooks";

type Props = {
  tooltip: string;
  placement?: TooltipPlacement;
  visible?: boolean;
  iconClassName?: string;
};

export const CustomTooltip = forwardRef<HTMLSpanElement, Props>(
  ({ tooltip, placement = "top", visible = true, iconClassName }, ref) => {
    const isMobile = useIsMobile();
    if (!tooltip || !visible || isMobile) return null;

    return (
      <Tooltip
        placement={placement}
        title={tooltip}
        arrow={false}
        overlayInnerStyle={{
          backgroundColor: "#8C8E94",
          padding: 20,
          fontSize: 14,
          fontFamily: "Onest",
          lineHeight: "24px"
        }}
      >
        <span ref={ref}>
          <Icon
            name="circle-help"
            className={cn(styles.question, iconClassName, { [styles.questionHover]: isMobile })}
          />
        </span>
      </Tooltip>
    );
  }
);

CustomTooltip.displayName = "CustomTooltip";
